import React from 'react';
import certificate from "../assets/images/certificate.jpg";

export default function Startup() {
    return (
        <div className="min-h-screen bg-gray-50 text-gray-800 p-6">
            <h2 className="text-2xl font-bold text-center mb-6">Startup & Innovation Cell</h2>

            <div className="max-w-4xl mx-auto space-y-8">

                {/* About Section */}
                <section className="bg-white shadow-md rounded-2xl p-6">
                    <h3 className="text-xl font-semibold mb-2">About the Cell</h3>
                    <p className="leading-relaxed">
                        Startup and Innovation Cell was established in 2024. The cell at Greenworld Foundation’s Arya Senior College, Manjari Tal. Rahuri Dist Ahilyanagar aims to create an ecosystem that brings together its students as young aspiring entrepreneurs by nurturing and empowering their startups. It helps coordinate and synergize innovation and entrepreneurship, turning ideas into action to produce job creators and social reformists.
                    </p>
                    <ul className="list-disc list-inside mt-4">
                        <li>Build an innovation and entrepreneurship mindset in the students.</li>
                        <li>Create a bunch of enthusiastic students with an entrepreneurial mindset.</li>
                    </ul>
                </section>

                {/* Certificate Section */}
                <section className="bg-white shadow-md rounded-2xl p-6 flex flex-col items-center">
                    <h3 className="text-xl font-semibold mb-4">Certificate</h3>
                    <img src={certificate} alt="Startup Certificate" className="w-[400px] h-[250px] object-cover rounded-xl shadow" />
                </section>

                {/* Committee Section */}
                <section className="bg-white shadow-md rounded-2xl p-6">
                    <h3 className="text-xl font-semibold mb-4">Committee Members</h3>
                    <div className="overflow-x-auto">
                        <table className="min-w-full table-auto border border-gray-300 text-sm">
                            <thead className="bg-gray-200 text-left">
                                <tr>
                                    <th className="border px-4 py-2">Details</th>
                                    <th className="border px-4 py-2">Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    ["Principle as Chairman of Innovation & Startup Committee", "Dr. Chandrakant Karbhari Waghachaure"],
                                    ["Representative from Faculty Member", "Yogesh Sheshrao Pawar"],
                                    ["Representative from Students - 1", "Rajeshawari Dadasaheb Shinde"],
                                    ["Representative from Students - 2", "Abhay Sudam Mundhe"],
                                    ["Representative from Industry Expert/Entrepreneur", "Narendra Nanasaheb Tuwar"],
                                    ["Representative from Alumni", "Sagar Rabhaji Vitnor"],
                                    ["Faculty Member as Coordinator & Member Secretary", "Bhausaheb Rangnath Bachkar"]
                                ].map(([role, name], idx) => (
                                    <tr key={idx} className="hover:bg-gray-50">
                                        <td className="border px-4 py-2">{role}</td>
                                        <td className="border px-4 py-2">{name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}
